<template>
  <h1>¡Ciao!</h1>
</template>

<script>
export default {

  name: 'Logout',

  async mounted () {
    await this.$store.dispatch('logout')
    this.$router.push('/login')
  },

  data () {
    return {

    }
  }
}
</script>
